<template>
  <div class="row">
    <div class="col-md-12">
      <dashboard-box :title="$t('nap_transfer.edit_campaign')">
        <template v-slot:preview>
          <div class="row">
            <div class="col-md-6">
              <b-form-group label="Kampanya Adı">
                <b-form-input
                    size="sm"
                    class="form-control form-control-solid"
                    type="text"
                    v-model="form.name"
                    name="name"
                    placeholder="Kampanya Adı"
                    @input="changeItName($event)"
                ></b-form-input>
              </b-form-group>

              <b-row>
                <b-col sm="6">
                  <b-form-group label="İlişkili Kampanya">
                    <b-form-select
                        size="sm"
                        class="form-control form-control-solid"
                        v-model="form.selected_campaign"
                        :options="campaigns"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group label="Promosyon Havuzu">
                    <b-form-select
                        size="sm"
                        class="form-control form-control-solid"
                        v-model="form.max_participation"
                        :options="max_participations"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group label="Site Alt Başlığı">
                    <b-form-input
                        size="sm"
                        class="form-control form-control-solid"
                        type="text"
                        placeholder="Site Alt Başlığı"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group label="Admin Tanımı">
                    <b-form-input
                        size="sm"
                        class="form-control form-control-solid"
                        type="number"
                        placeholder="Admin Tanımı"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="12">
                  <b-form-group label="Onay Mesajı">
                    <b-form-textarea
                        size="sm"
                        id="textarea"
                        class="form-control form-control-solid"
                        v-model="form.confirmation_message"
                        rows="3"
                        max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>

              <div class="row">
                <div class="col-md-3">
                  <b-form-group>
                    <b-form-checkbox value="accepted" unchecked-value="not_accepted">
                      Aktif
                    </b-form-checkbox>
                  </b-form-group>
                </div>

                <div class="col-md-3">
                  <b-form-group>
                    <b-form-checkbox value="accepted" unchecked-value="not_accepted">
                      Live
                    </b-form-checkbox>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group>
                    <b-form-checkbox value="accepted" unchecked-value="not_accepted">
                      Mobilde Göster
                    </b-form-checkbox>
                  </b-form-group>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="col-md-6">
              <b-row>
                <b-col sm="6">
                  <b-form-group label="Kampanya URL">
                    <b-form-input
                        class="form-control form-control-solid"
                        type="text"
                        name="name"
                        placeholder="Kampanya URL"
                        v-model="form.slug"
                        value=""
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group label="Puan">
                    <b-form-input
                        size="sm"
                        class="form-control form-control-solid"
                        type="number"
                        placeholder="Puan"
                        v-model="form.point"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group label="Katılım Periyodu">
                    <b-form-select
                        size="sm"
                        class="form-control form-control-solid"
                        v-model="form.period_of_participation"
                        :options="period_of_participation"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group label="Katılım Hakkı">
                    <b-form-select
                        size="sm"
                        class="form-control form-control-solid"
                        v-model="form.limit_participation"
                        :options="limit_participation"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group :label="$t('users.start_date')" label-for="input-2">
                    <b-form-input
                        size="sm"
                        class="form-control form-control-solid"
                        type="date"
                        v-model="form.start_date"
                        required
                        :placeholder="$t('users.start_date')"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group :label="$t('users.end_date')" label-for="input-2">
                    <b-form-input
                        size="sm"
                        class="form-control form-control-solid"
                        type="date"
                        v-model="form.end_date"
                        required
                        :placeholder="$t('users.end_date')"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <h3 class="font-size-lg text-dark font-weight-bold mb-6">Kampanya Detay Sayfası Görseli</h3>
                  <div class="separator separator-dashed my-6"></div>
                  <b-form-group label="750x330px" label-for="file-default">
                    <b-form-file id="file-default" placeholder="Görsel seçiniz" browse-text="Seçim yap"></b-form-file>
                  </b-form-group>
                  <img style="width:100%;border-radius: 8px;" src="http://cdn.napolyon.com/napolyon/profilgorev/PB_kisiselbilgiler_750x330.png" alt="">
                </b-col>
                <b-col sm="6">
                  <h3 class="font-size-lg text-dark font-weight-bold mb-6">Kampanya Logo</h3>
                  <div class="separator separator-dashed my-6"></div>
                  <b-form-group label="350x250px" label-for="file-default1">
                    <b-form-file id="file-default1" placeholder="Görsel seçiniz" browse-text="Seçim yap"></b-form-file>
                  </b-form-group>
                  <img style="width:100%;border-radius: 8px;max-height: 130px" src="img/4.4cee519f.png" alt="">
                </b-col>
              </b-row>
            </div>
          </div>
        </template>
        <template v-slot:foot>
          <b-button type="submit" variant="primary" class="fa-pull-right"><i class="fa fa-save"></i> {{ $t('general.save') }}</b-button>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import RichTextArea from "@/view/pages/vue-bootstrap/RichTextArea";

export default {
  name: "AddTransferCampaign",
  components: { DashboardBox,RichTextArea },
  methods: {
    changeItName(){
      this.form.slug = _.kebabCase(this.form.name);
    },
  },
  data() {
    return {
      form : {
        name : 'Flormar',
        slug : 'flormar',
        selected_campaign: 'Yılbaşı 2021',
        max_participation: 3,
        point : '500',
        start_date: '2020-12-15',
        end_date: '2021-02-14',
        period_of_participation : 1,
        limit_participation : 'Sınırsız',
        confirmation_message : 'Kodunuz, en fazla 3 iş günü* içerisinde gerekli kontrollerin yapılmasının ardından Napolyon.com e-postanıza gönderilecektir. <br /><br /> * Resmi tatiller ve bayramlar hariçtir.'
      },
      campaigns: [
        { text: this.$t('general.select'), value: null } ,
        'İletişim Araçları',
        'Yılbaşı 2021',
        'test',
        'CRM_pandemisonrasi_satinalma',
        'crm_asi',
        '2021 Beklentiler',
        'Tv Alışkanlıkları',
        'Uzaktan Eğitim'
      ],
      max_participations: [{ text: this.$t('general.select'), value: null } , 1,2,3,4,5,6,7,8],
      period_of_participation : [{ text: this.$t('general.select'), value: null } , 1,2,3,4,5,6,7,8],
      limit_participation : [ 'Sınırsız',1,2,3,4,5,6,7,8],
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('menu.nap_transfer_campaigns'), route: "NapTransferCampaigns" },
      { title: this.$t('nap_transfer.add_campaign') }
    ]);
  },

}
</script>

<style scoped>

</style>
